import React, { Component } from "react";
import "./SelectCarCard.css";
import FaCalendar from "react-icons/lib/fa/calendar";
import FaAutomobile from "react-icons/lib/fa/automobile";
import FaExternalLink from "react-icons/lib/fa/external-link";
import FaCheck from "react-icons/lib/fa/check";
import { connect } from "react-redux";
import classnames from "classnames";
import { getTranslate } from "react-localize-redux";
import { formValueSelector, Field, reduxForm } from "redux-form";
import creditCards from "../../assets/images/creditcards.png";
import Gel from "../Svgs/Gel";
import { BeatLoader } from "react-spinners";

class SelectCarCard extends Component {
  handleTermsAndCondPopup = () => {
    document
      .getElementById("policy-registration-scrollbar")
      .classList.toggle("policy-registration-scrollbar-display");
    document
      .getElementById("policy-create-card")
      .classList.toggle("policy-create-card-overflow");
  };

  render() {
    const {
      vehicleCategoryName,
      translate,
      issueDateDiff,
      dayType,
      startDate,
      endDate,
      premium,
      canPay,
      isLoading,
      onClick,
      handleSelectedBank,
      ecommerceList,
      selectedBank,
      bankType,
    } = this.props;
    return (
      <div className="select-car-card">
        <div className="select-car-header">
          <FaAutomobile className="select-car-icon" />
          <div>
            <h3 className="select-car-header-text">
              {vehicleCategoryName ? translate(vehicleCategoryName) : "- - - -"}
            </h3>
            <p className="select-car-header-description">
              {" "}
              {translate("transportCategory")}
            </p>
          </div>
        </div>
        <div className="policy-info">
          <div className="policy-view-container">
            <div className="policy-info-period">
              <div className="policy-info-period-text-content">
                <p className="policy-info-period-text">
                  {" "}
                  {translate("active")}
                </p>
                <p className="policy-info-period-text">
                  {" "}
                  <FaCalendar /> {translate("period")}
                </p>
              </div>
              <div className="policy-info-period-value">
                <span>{issueDateDiff ? issueDateDiff : "_ _"}</span>{" "}
                <span className="policy-info-period-day">
                  {dayType ? translate(dayType) : "---"}
                </span>
              </div>
            </div>
            <div className="policy-info-periods">
              <p className="policy-info-calendar-startDate">
                {startDate ? startDate.format("DD MMM YYYY") : "__/__/__"}
              </p>
              <div className="policy-info-calendar-line"></div>
              <p className="policy-info-calendar-endDate">
                {endDate ? endDate.format("DD MMM YYYY") : "__/__/__"}
              </p>
            </div>
          </div>
        </div>
        <div className="policy-price">
          <p className="policy-price-description"> {translate("price")}</p>
          <div className="policy-price-value">
            {premium ? premium : "-" + "-"}
            <p className="policy-price-lari">
              <Gel width={25} />{" "}
            </p>
          </div>
        </div>
        <div className="insurer-conditions">
          <div className="policy-view-container">
            <div
              onClick={this.handleTermsAndCondPopup}
              className="insurer-conditions-text"
            >
              {translate("insuranceCondition")} <FaExternalLink />
            </div>
          </div>
        </div>
        <div className="policy-pay">
          <div className="policy-view-container">
            {ecommerceList && (
              <form>
                <br />
                <span className="select-bank">{translate("selectBank")}</span>
                <div className="input-radio-group">
                  {ecommerceList.map((item, index) => (
                    <div key={index}>
                      <div className="input-radio">
                        <label className="input-radio-label">
                          <Field
                            name="ecommerceListForm"
                            value={item.bank}
                            component="input"
                            type="radio"
                            checked={selectedBank === item.bank}
                            onChange={() => {
                              handleSelectedBank(item.bank);
                            }}
                          />
                          <span className="input-radio-circle" />
                          <span className="input-radio-text">
                            {translate(bankType[item.bank])}
                          </span>
                        </label>
                      </div>
                      <div className="card-type">
                        <span className="card-type__label">{translate("geoCard")}:</span>
                        <span className="card-type__value">{item.cardProcessingFee}%</span>
                      </div>
                      <div className="card-type">
                        <span className="card-type__label">{translate("notGeoCard")}:</span>
                        <span className="card-type__value">{item.foreignCardProcessingFee}%</span>
                      </div>
                    </div>
                  ))}
                </div>
                <br />
              </form>
            )}

            {/* <h4 className="policy-pay-text">
              {" "}
              {translate("payAdditionalText")}
            </h4> */}
            {isLoading && (
              // <button className="policy-pay-btn-disable">
              //     {translate('pleaseWait')}...
              // </button>
              <div className="Loader">
                <BeatLoader size={11} color={"#B5DB39"} />
              </div>
            )}
            {!isLoading && (
              // <button
              //   className={classnames("policy-pay-btn-disable", {
              //     "policy-pay-btn":
              //       canPay && (selectedBank || selectedBank === 0),
              //   })}
              //   disabled={!canPay || (selectedBank !== 0 && !selectedBank)}
              //   onClick={onClick}
              // >
              //   {" "}
              //   {translate("pay")}
              // </button>

              <button
                className={classnames("policy-pay-btn-disable", {
                  "policy-pay-btn":
                    canPay,
                })}
                disabled={!canPay}
                onClick={onClick}
              >
                {" "}
                {translate("pay")}
              </button>
            )}
          </div>
        </div>
      </div>
    );
  }
}
SelectCarCard = reduxForm({
  form: "ecommerceListForm", // a unique identifier for this form
})(SelectCarCard);

const selector = formValueSelector("CreatePolicyForm");

const mapStateToProps = (state) => {
  const startDate = selector(state, "startDate");
  const endDate = selector(state, "endDate");
  const issueDateDiff = selector(state, "issueDateDiff");
  const dayType = selector(state, "dayType");
  const vehicleCategoryName = selector(state, "vehicleCategoryName");
  const premium = selector(state, "premium");
  return {
    translate: getTranslate(state.locale),
    startDate,
    endDate,
    issueDateDiff,
    dayType,
    premium,
    vehicleCategoryName,
  };
};

export default connect(mapStateToProps)(SelectCarCard);



// WEBPACK FOOTER //
// ./src/components/Select-car-card/SelectCarCard.js